import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    data: { title: 'LOGIN.TITLE' },
    loadComponent: () =>
      import('./routes/misc/login-page/login-page.component').then(
        (m) => m.LoginPageComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'menu-management',
    data: { title: 'NAV.MENU_MANAGEMENT.TITLE' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'menus',
        data: { title: 'NAV.MENU_MANAGEMENT.MENUS' },
        loadComponent: () =>
          import(
            './routes/menu-management/menus-page/menus-page.component'
          ).then((m) => m.MenusPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'categories',
        data: { title: 'NAV.MENU_MANAGEMENT.CATEGORIES' },
        loadComponent: () =>
          import(
            './routes/menu-management/categories-page/categories-page.component'
          ).then((m) => m.CategoriesPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'products',
        data: { title: 'NAV.MENU_MANAGEMENT.PRODUCTS' },
        loadComponent: () =>
          import(
            './routes/menu-management/products-page/products-page.component'
          ).then((m) => m.ProductsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'option-groups',
        data: { title: 'NAV.MENU_MANAGEMENT.OPTION_GROUPS' },
        loadComponent: () =>
          import(
            './routes/menu-management/options-page/option-groups-page.component'
          ).then((m) => m.OptionGroupsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'master-catalog',
        data: { title: 'NAV.MENU_MANAGEMENT.MASTER_CATALOG', icon: 'menu_book' },
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            redirectTo: 'products',
            pathMatch: 'full',
          },
          {
            path: 'products',
            data: { title: 'NAV.MENU_MANAGEMENT.MASTER_PRODUCTS', icon: 'inventory' },
            loadComponent: () =>
              import(
                './routes/menu-management/master-product-page/master-product-page.component'
              ).then((m) => m.MasterProductPageComponent),
            canActivate: [AuthGuard],
          },
          {
            path: 'categories',
            data: { title: 'NAV.MENU_MANAGEMENT.MASTER_CATEGORIES', icon: 'category' },
            loadComponent: () =>
              import(
                './routes/menu-management/master-categories-page/master-categories-page.component'
              ).then((m) => m.MasterCategoriesPageComponent),
            canActivate: [AuthGuard],
          },
        ],
      },
    ],
  },
  {
    path: 'inventory-management',
    data: { title: 'NAV.INVENTORY_MANAGEMENT.TITLE' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'definitions',
        data: { title: 'NAV.INVENTORY_MANAGEMENT.DEFINITIONS', icon: 'folder_open' },
        canActivate: [AuthGuard],
        children: [
          {
            path: 'inventory',
            data: { title: 'NAV.INVENTORY_MANAGEMENT.INVENTORY', icon: 'inventory_2' },
            loadComponent: () =>
              import(
                './routes/inventory-management/inventory-page/inventory-page.component'
              ).then((m) => m.InventoryPageComponent),
            canActivate: [AuthGuard],
          },
          {
            path: 'inventory-groups',
            data: { title: 'NAV.INVENTORY_MANAGEMENT.INVENTORY_GROUPS', icon: 'layers' },
            loadComponent: () =>
              import(
                './routes/inventory-management/inventory-groups-page/inventory-groups-page.component'
              ).then((m) => m.InventoryGroupsPageComponent),
            canActivate: [AuthGuard],
          },
          {
            path: 'warehouses',
            data: { title: 'NAV.INVENTORY_MANAGEMENT.WAREHOUSES', icon: 'warehouse' },
            loadComponent: () =>
              import(
                './routes/inventory-management/warehouses-page/warehouses-page.component'
              ).then((m) => m.WarehousesPageComponent),
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'inventory-batches',
        data: { title: 'NAV.INVENTORY_MANAGEMENT.INVENTORY_BATCHES' },
        loadComponent: () =>
          import(
            './routes/inventory-management/inventory-batches-page/inventory-batches-page.component'
          ).then((m) => m.InventoryBatchesPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'waybills',
        data: { title: 'NAV.INVENTORY_MANAGEMENT.WAYBILLS' },
        loadComponent: () =>
          import(
            './routes/inventory-management/waybills-page/waybills-page.component'
          ).then((m) => m.WaybillsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'invoices',
        data: { title: 'NAV.INVENTORY_MANAGEMENT.INVOICES' },
        loadComponent: () =>
          import(
            './routes/inventory-management/invoices-page/invoices-page.component'
          ).then((m) => m.InvoicesPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'production',
        data: { title: 'NAV.INVENTORY_MANAGEMENT.PRODUCTION', icon: 'precision_manufacturing' },
        loadComponent: () =>
          import(
            './routes/reports/production-page/production-page.component'
          ).then((m) => m.ProductionPageComponent),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'store-management',
    data: { title: 'NAV.STORE_MANAGEMENT.TITLE' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'users',
        data: { title: 'NAV.STORE_MANAGEMENT.USERS.TITLE' },
        canActivate: [AuthGuard],
        children: [
          {
            path: 'staff',
            data: { title: 'NAV.STORE_MANAGEMENT.USERS.STAFF' },
            loadComponent: () =>
              import(
                './routes/store-management/users/staff/staff-page.component'
              ).then((m) => m.StaffPageComponent),
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'layout',
        data: { title: 'NAV.STORE_MANAGEMENT.LAYOUT.TITLE' },
        canActivate: [AuthGuard],
        children: [
          {
            path: 'floors',
            data: { title: 'NAV.STORE_MANAGEMENT.LAYOUT.FLOORS' },
            loadComponent: () =>
              import(
                './routes/store-management/layout/floors/floors-page.component'
              ).then((m) => m.FloorsPageComponent),
            canActivate: [AuthGuard],
          },
          {
            path: 'tables',
            data: { title: 'NAV.STORE_MANAGEMENT.LAYOUT.TABLES' },
            loadComponent: () =>
              import(
                './routes/store-management/layout/tables/tables-page.component'
              ).then((m) => m.TablesPageComponent),
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'configuration',
        data: { title: 'NAV.STORE_MANAGEMENT.CONFIGURATION.TITLE' },
        canActivate: [AuthGuard],
        children: [
          {
            path: 'devices',
            data: { title: 'NAV.STORE_MANAGEMENT.CONFIGURATION.DEVICES' },
            loadComponent: () =>
              import(
                './routes/store-management/configuration/devices-page/devices-page.component'
              ).then((m) => m.DevicesPageComponent),
            canActivate: [AuthGuard],
          },
          {
            path: 'printers',
            data: { title: 'NAV.STORE_MANAGEMENT.CONFIGURATION.PRINTERS' },
            loadComponent: () =>
              import(
                './routes/store-management/configuration/printers-page/printers-page.component'
              ).then((m) => m.PrintersPageComponent),
            canActivate: [AuthGuard],
          },
          {
            path: 'points',
            data: { title: 'NAV.STORE_MANAGEMENT.CONFIGURATION.POINTS' },
            loadComponent: () =>
              import(
                './routes/store-management/configuration/points-page/points-page.component'
              ).then((m) => m.PointsPageComponent),
            canActivate: [AuthGuard],
          },
        ],
      },
    ],
  },
  {
    path: 'reports',
    data: { title: 'NAV.REPORTS.TITLE' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'end-of-day',
        data: { title: 'NAV.REPORTS.END_OF_DAY.TITLE' },
        loadComponent: () =>
          import(
            './routes/reports/end-of-day-report-page/end-of-day-report-page.component'
          ).then((m) => m.EndOfDayReportPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'register',
        data: { title: 'NAV.REPORTS.REGISTER.TITLE' },
        loadComponent: () =>
          import(
            './routes/reports/register-report-page/register-report-page.component'
          ).then((m) => m.RegisterReportPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'summary',
        data: { title: 'NAV.REPORTS.SUMMARY.TITLE' },
        loadComponent: () =>
          import(
            './routes/reports/summary-report-page/summary-report-page.component'
          ).then((m) => m.SummaryReportPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'sessions',
        data: { title: 'NAV.REPORTS.SESSION.TITLE' },
        loadComponent: () =>
          import(
            './routes/reports/session-report-page/session-report-page.component'
          ).then((m) => m.SessionReportPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'inventory-movements',
        data: { title: 'NAV.REPORTS.INVENTORY_MOVEMENTS.TITLE', icon: 'swap_horiz' },
        loadComponent: () =>
          import(
            './routes/reports/production-page/production-page.component'
          ).then((m) => m.ProductionPageComponent),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'settings',
    data: { title: 'NAV.SETTINGS.TITLE' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'general',
        data: { title: 'NAV.SETTINGS.GENERAL' },
        loadComponent: () =>
          import(
            './routes/settings/general-settings-page/general-settings-page.component'
          ).then((m) => m.GeneralSettingsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'app-settings',
        data: { title: 'NAV.SETTINGS.APP_SETTINGS' },
        loadComponent: () =>
          import(
            './routes/settings/app-settings-page/app-settings-page.component'
          ).then((m) => m.AppSettingsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'payment-provider',
        data: { title: 'NAV.SETTINGS.PAYMENT_PROVIDER' },
        loadComponent: () =>
          import(
            './routes/settings/payment-provider-settings-page/payment-provider-settings-page.component'
          ).then((m) => m.PaymentProviderSettingsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'subscription',
        data: { title: 'NAV.SETTINGS.SUBSCRIPTION' },
        loadComponent: () =>
          import(
            './routes/settings/subscription-page/subscription-page.component'
          ).then((m) => m.SubscriptionPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'tools',
        data: { title: 'NAV.SETTINGS.TOOLS', icon: 'qr_code_2' },
        loadComponent: () =>
          import('./routes/settings/tools-page/tools-page.component').then(
            (m) => m.ToolsPageComponent
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'accounting',
    data: { title: 'NAV.ACCOUNTING.TITLE' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'accounts',
        data: { title: 'NAV.ACCOUNTING.ACCOUNTS', icon: 'account_balance_wallet' },
        loadComponent: () =>
          import(
            './routes/accounting/accounts-page/accounts-page.component'
          ).then((m) => m.AccountsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'transactions',
        data: { title: 'NAV.ACCOUNTING.TRANSACTIONS', icon: 'receipt_long' },
        loadComponent: () =>
          import(
            './routes/accounting/account-transactions-page/account-transactions-page.component'
          ).then((m) => m.AccountTransactionsPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'receivables',
        data: { title: 'NAV.ACCOUNTING.RECEIVABLES', icon: 'arrow_circle_down' },
        loadComponent: () =>
          import(
            './routes/accounting/account-receivables-page/account-receivables-page.component'
          ).then((m) => m.AccountReceivablesPageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'payables',
        data: { title: 'NAV.ACCOUNTING.PAYABLES', icon: 'arrow_circle_up' },
        loadComponent: () =>
          import(
            './routes/accounting/account-payables-page/account-payables-page.component'
          ).then((m) => m.AccountPayablesPageComponent),
        canActivate: [AuthGuard],
      },
    ],
  },

  { path: '', redirectTo: '/menu-management/menus', pathMatch: 'full' },
  { path: '**', redirectTo: '/menu-management/menus' },
];
